export default "__VITE_ASSET__BEQzhMwF__"